import React from 'react';
import { AiFillHome, AiOutlineWeiboCircle } from 'react-icons/ai';
import { MdOutlineQuiz } from 'react-icons/md';
import { Link } from 'react-router-dom';
import img1 from '../../../asset/img/screencapture-snazzy-marigold-5a4d31-netlify-app-blog-2022-12-12-16_19_28.png'
import img2 from '../../../asset/img/screencapture-snazzy-marigold-5a4d31-netlify-app-home-1-2022-12-12-16_19_08.png'
import img3 from '../../../asset/img/screencapture-snazzy-marigold-5a4d31-netlify-app-home-2022-12-12-16_18_32.png'

const Brainless = () => {
    return (
        <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-20">
            <div className="grid gap-10 lg:grid-cols-2">
                <div className="flex flex-col justify-center md:pr-8 xl:pr-0 lg:max-w-lg">
                    <div className="flex items-center justify-center w-16 h-16 mb-4 rounded-full bg-teal-accent-400">
                        <MdOutlineQuiz className="text-teal-900 w-7 h-7"></MdOutlineQuiz>

                    </div>
                    <div className="max-w-xl mb-6">
                        <h2 className="max-w-lg mb-6 font-sans text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl sm:leading-none">
                            Brainless Quiz

                        </h2>
                        <p className="text-base text-gray-700 md:text-lg">
                            YOU CAN PLAY QUIZES HERE. <br />
                            IF YOU CLICK ON OPTIONS IT WILL CONFIRM YOU BY TOAST. <br />
                            <span className=' text-teal-500'>TECHNOLOGIES:</span> REACTJS,TAILWIND,DAISYUI,FIREBASE
                        </p>
                    </div>
                    <div className=' flex gap-2'>
                        <div>
                            <Link
                                to='/'

                                className="inline-flex items-center font-semibold transition-colors duration-200 text-deep-purple-accent-400 hover:text-deep-purple-800"
                            >
                                Home
                                <AiFillHome className="inline-block w-3 ml-2"></AiFillHome>
                            </Link>
                        </div>
                        <div>
                            <a
                                href='https://snazzy-marigold-5a4d31.netlify.app/home'
                                target='_blank'
                                rel='noreferrer'
                                className="inline-flex items-center font-semibold transition-colors duration-200 text-deep-purple-accent-400 hover:text-deep-purple-800"
                            >
                                Live
                                <AiOutlineWeiboCircle className="inline-block w-3 ml-2"></AiOutlineWeiboCircle>
                            </a>
                        </div>
                    </div>
                </div>
                <div className="flex items-center justify-center -mx-4 lg:pl-8">
                    <div className="flex flex-col items-end px-3">
                        <img
                            className="object-cover mb-6 rounded shadow-lg h-28 sm:h-48 xl:h-56 w-28 sm:w-48 xl:w-56"
                            src={img2}
                            alt=""
                        />
                        <img
                            className="object-cover w-20 h-20 rounded shadow-lg sm:h-32 xl:h-40 sm:w-32 xl:w-40"
                            src={img1}
                            alt=""
                        />
                    </div>
                    <div className="px-3">
                        <img
                            className="object-cover w-40 h-40 rounded shadow-lg sm:h-64 xl:h-80 sm:w-64 xl:w-80"
                            src={img3}
                            alt=""
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Brainless;